module.exports = __webpack_public_path__ + "img/furnitureshop-banner.88cde43b.png";